module.exports = __webpack_public_path__ + "img/part5-7.e1d5af06.png";